import { useMemo } from 'react';

import { useSelectedProjectTemplateNode } from 'state/selectedProject/selectedProjectHooks';

export function useDecompositionRelation(templateNodeId: string) {
  const templateNode = useSelectedProjectTemplateNode(templateNodeId);
  return useMemo(() => {
    const relation = templateNode?.relations.find((r) => r.isDecomposable);
    return {
      relationId: relation?.id ?? '',
      technicalName: templateNode?.technicalName ?? ''
    };
  }, [templateNode]);
}
